export default __webpack_public_path__ + "static/media/ic-pinterset.e3b652f9.svg";